<!-- Add/Edit Vehicle Drawer -->
<nz-drawer
  [nzVisible]="addVchleFrm"
  nzPlacement="right"
  [nzTitle]="sdbarHdr"
  (nzOnClose)="close()"
  [nzWidth]="500"
>
  <ng-container *nzDrawerContent>
    <form nz-form [formGroup]="addVhcldtlsform">
      <div nz-row [nzGutter]="[12, 12]">
        <div nz-col nzSpan="12">
          <nz-form-label nzRequired>Client</nz-form-label>
          <nz-form-item>
            <nz-form-control [nzErrorTip]="'Please select client'">
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Client"
                formControlName="clnt"
              >
                @for (c of clnts; track c) {
                <nz-option
                  [nzLabel]="c.clnt_nm"
                  [nzValue]="c.clnt_id"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="12">
          <nz-form-label nzRequired>Tenant</nz-form-label>
          <nz-form-item>
            <nz-form-control [nzErrorTip]="'Please select tenant'">
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Tenant"
                formControlName="tnt"
              >
                @for (t of tnts; track t) {
                <nz-option
                  [nzLabel]="t.tnt_nm"
                  [nzValue]="t.tnt_id"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="12">
          <nz-form-label nzRequired>Vehicle Number</nz-form-label>
          <nz-form-item>
            <nz-form-control [nzErrorTip]="'Please enter vehicle number'">
              <input
                nz-input
                formControlName="veh_nu"
                placeholder="Vehicle Number"
              />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="12">
          <nz-form-label nzRequired>Vehicle Type</nz-form-label>
          <nz-form-item>
            <nz-form-control [nzErrorTip]="'Please select vehicle type'">
              <nz-select
                nzAllowClear
                nzPlaceHolder="Select Vehicle Type"
                formControlName="veh_typ"
              >
                <nz-option nzValue="1" nzLabel="Clap"></nz-option>
                <nz-option nzValue="0" nzLabel="Non-Clap"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="12">
          <nz-form-label nzRequired>Ownership Type</nz-form-label>
          <nz-form-item>
            <nz-form-control [nzErrorTip]="'Please select ownership type'">
              <nz-select
                nzAllowClear
                nzPlaceHolder="Select Ownership Type"
                formControlName="asrt_ownr_id"
              >
                <nz-option nzValue="1" nzLabel="Own"></nz-option>
                <nz-option nzValue="2" nzLabel="Hired"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        @if (mstrDta) {
        <div nz-col nzSpan="12">
          <nz-form-label nzRequired>IMEI Number</nz-form-label>
          <nz-form-item>
            <nz-form-control
              [nzErrorTip]="'IMEI number is required'"
              [nzHasFeedback]="true"
            >
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Device"
                formControlName="imei_nu"
                (ngModelChange)="ImeiSlct($event)"
                [nzStatus]="
                  addVhcldtlsform.get('imei_nu')?.invalid &&
                  addVhcldtlsform.get('imei_nu')?.touched
                    ? 'error'
                    : ''
                "
              >
                @for (c of mstrDta.Imei; track c) {
                <nz-option
                  [nzLabel]="c.imei_nu"
                  [nzValue]="c.dvce_id"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        } @if (mstrDta) {
        <div nz-col nzSpan="12">
          <nz-form-label>Home Fence</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Home Fence"
                formControlName="hme_fnce"
              >
                @for (c of mstrDta.Fence; track c) {
                <nz-option
                  [nzLabel]="c.fnce_nm"
                  [nzValue]="c.fnce_id"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        } @if (editform) {
        <div nz-col nzSpan="24">
          <nz-form-label>Select ULB</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                nzAllowClear
                nzPlaceHolder="Select ULB"
                formControlName="ULB"
                (ngModelChange)="editUlb($event)"
              >
                @for (c of tnts; track c) {
                <nz-option
                  [nzLabel]="c.tnt_nm"
                  [nzValue]="c.tnt_id"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        } @if (mstrDta) {
        <div nz-col nzSpan="12">
          <nz-form-label nzRequired>Vehicle Category</nz-form-label>
          <nz-form-item>
            <nz-form-control [nzErrorTip]="'Please select vehicle category'">
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Vehicle Category"
                formControlName="veh_ctgry"
                (ngModelChange)="ctgrtSlct($event)"
              >
                @for (c of mstrDta.ctgry; track c) {
                <nz-option
                  [nzLabel]="c.asrt_ctgry_nm"
                  [nzValue]="c.asrt_ctgry_id"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        } @if (mstrDta) {
        <div nz-col nzSpan="12">
          <nz-form-label nzRequired>Vehicle Group</nz-form-label>
          <nz-form-item>
            <nz-form-control [nzErrorTip]="'Please select vehicle group'">
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Vehicle Group"
                formControlName="veh_grp"
                (ngModelChange)="grpSlct($event)"
              >
                @for (c of mstrDta.Groups; track c) {
                <nz-option
                  [nzLabel]="c.asrt_grp_nm"
                  [nzValue]="c.asrt_grp_id"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        } @if (mstrDta) {
        <div nz-col nzSpan="12">
          <nz-form-label nzRequired>Vehicle Status</nz-form-label>
          <nz-form-item>
            <nz-form-control [nzErrorTip]="'Please select vehicle status'">
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Vehicle Status"
                formControlName="veh_sts"
              >
                @for (c of mstrDta.status; track c) {
                <nz-option
                  [nzLabel]="c.asrt_sts_nm"
                  [nzValue]="c.asrt_sts_id"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        } @if (mstrDta) {
        <div nz-col nzSpan="12">
          <nz-form-label nzRequired>Icon</nz-form-label>
          <nz-form-item>
            <nz-form-control [nzErrorTip]="'Please select icon'">
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Icon"
                formControlName="icn_pth"
              >
                @for (c of mstrDta.imgs; track c) {
                <nz-option
                  [nzLabel]="c.icon_path"
                  [nzValue]="c.icon_path"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        } @if (mstrDta) {
        <div nz-col nzSpan="12">
          <nz-form-label nzRequired>Tracking Type</nz-form-label>
          <nz-form-item>
            <nz-form-control [nzErrorTip]="'Please select tracking type'">
              <nz-select
                nzAllowClear
                nzPlaceHolder="Select Tracking Type"
                formControlName="blng_prmtr_id"
              >
                <nz-option nzValue="1" nzLabel="Distance"></nz-option>
                <nz-option nzValue="2" nzLabel="Working Hours"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        } @if (mstrDta) {
        <div nz-col nzSpan="12">
          <nz-form-label>Minimum Distance (km)</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <input
                nz-input
                type="number"
                formControlName="min_dst_ct"
                placeholder="Minimum Distance"
                min="0"
                step="0.01"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
        } @if (mstrDta) {
        <div nz-col nzSpan="12">
          <nz-form-label>Maximum Speed Limit (km/h)</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <input
                nz-input
                type="number"
                formControlName="max_spd_lmt_ct"
                placeholder="Maximum Speed Limit"
                min="0"
                step="1"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
        }

        <div nz-col nzSpan="24">
          <label
            nz-checkbox
            [(ngModel)]="checked"
            (ngModelChange)="ign_ckd($event)"
            [ngModelOptions]="{ standalone: true }"
          >
            Select for Ignition Connection
          </label>
        </div>

        @if (usdImei) {
        <div
          nz-col
          nzSpan="24"
          style="
            margin-top: 12px;
            background-color: #fef3c7;
            padding: 12px;
            border-radius: 8px;
          "
        >
          <span
            nz-icon
            nzType="info-circle"
            nzTheme="outline"
            class="text-amber-600"
          ></span>
          &nbsp;
          <span class="font-semibold text-amber-800">
            The Selected IMEI Number Was Already Assigned To {{ asrt_nm }} Of
            {{ tnt_nm }}
            <!--
              cndtn is "the holding vehicle is in a ULB this user can act on".
              It was computed in ImeiSlct and never used, so the unassign link
              was offered even when the holder belongs to another ULB - where
              POST /drivers/Unassign/Device answers 403 (assertVehicleOwned) and
              the user is left clicking a link that cannot work. The saving of
              this vehicle is blocked either way; only the remedy differs.
            -->
            @if (cndtn) {
            <span
              class="text-blue-600 hover:text-blue-800 cursor-pointer underline"
              (click)="cnfrmDvcUnAssgn()"
            >
              Click Here
            </span>
            To Unassign Device & Continue
            } @else { — it must be unassigned in that ULB before it can be used
            here. }
          </span>
        </div>
        }

        <div
          nz-col
          nzSpan="24"
          class="flex justify-end"
          style="gap: 16px; margin-top: 20px"
        >
          <button
            nz-button
            nzType="default"
            nzDanger
            (click)="close()"
            style="padding: 0 24px"
          >
            Cancel
          </button>
          <button
            nz-button
            nzType="primary"
            (click)="addVechile()"
            [nzLoading]="isSaving"
            [disabled]="
              isSaving ||
              !addVhcldtlsform.valid ||
              !perms.canWrite() ||
              usdImei
            "
            [title]="
              !perms.canWrite()
                ? 'You do not have permission to save'
                : usdImei
                ? 'This IMEI is already assigned to another vehicle'
                : ''
            "
            class="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700"
            style="padding: 0 32px"
          >
            {{ isSaving ? "Saving..." : "Save" }}
          </button>
        </div>
      </div>
    </form>
  </ng-container>
</nz-drawer>

<!-- Add Device Drawer -->
<nz-drawer
  [nzVisible]="addDvceFrm"
  nzPlacement="right"
  nzTitle="Add New Device"
  (nzOnClose)="closedvcFrm()"
  [nzWidth]="500"
>
  <ng-container *nzDrawerContent>
    <div nz-row [nzGutter]="[12, 12]">
      <div nz-col nzSpan="12">
        <nz-form-label>Client</nz-form-label>
        <nz-form-item>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select Client"
              [(ngModel)]="selectedclnt"
              (ngModelChange)="slct_clnt($event)"
            >
              @for (c of clnts; track c) {
              <nz-option
                [nzLabel]="c.clnt_nm"
                [nzValue]="c.clnt_id"
              ></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="12">
        <nz-form-label>Tenant</nz-form-label>
        <nz-form-item>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select Tenant"
              [(ngModel)]="selectedTnt"
              (ngModelChange)="slct_tnt($event)"
            >
              @for (t of tnts; track t) {
              <nz-option [nzLabel]="t.tnt_nm" [nzValue]="t.tnt_id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="24">
        <nz-form-label>Enter Device Number</nz-form-label>
        <nz-form-item>
          <nz-form-control>
            <input
              nz-input
              [(ngModel)]="dvce_nm"
              placeholder="Device Number"
              [ngModelOptions]="{ standalone: true }"
            />
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="24">
        <nz-form-label
          >Device Type<span class="text-red-500">*</span></nz-form-label
        >
        <nz-form-item>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select Device Type"
              [(ngModel)]="dvce_type_id"
            >
              @for (v of dvceTypeLst; track v) {
              <nz-option
                [nzLabel]="v.dvce_type_nm"
                [nzValue]="v.dvce_type_id"
              ></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="24">
        <nz-form-label
          >Device Model<span class="text-red-500">*</span></nz-form-label
        >
        <nz-form-item>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select Device Model"
              [(ngModel)]="dvce_ctgry_id"
            >
              @for (v of dvceCtgryLst; track v) {
              <nz-option
                [nzLabel]="v.dvce_ctgry_nm"
                [nzValue]="v.dvce_ctgry_id"
              ></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="24">
        <nz-form-label
          >IMEI Number<span class="text-red-500">*</span></nz-form-label
        >
        <nz-form-item>
          <nz-form-control>
            <!-- type="text" + inputmode, NOT type="number" (audit obs #4).
            A number input binds through valueAsNumber, so a 17- or
            19-digit IMEI - production holds both - exceeds
            MAX_SAFE_INTEGER and is ROUNDED before it is ever posted,
            and a leading zero is dropped outright. inputmode keeps the
            numeric keypad on mobile; the digits-only rule is enforced
            by isValidImei() and again by the API. -->
            <input
              nz-input
              type="text"
              inputmode="numeric"
              maxlength="20"
              [(ngModel)]="dvcimei_nu"
              placeholder="IMEI Number (10 to 20 digits)"
              [ngModelOptions]="{ standalone: true }"
            />
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="24">
        <nz-form-label>Mobile Number</nz-form-label>
        <nz-form-item>
          <nz-form-control>
            <input
              nz-input
              type="number"
              [(ngModel)]="mble_nu"
              placeholder="Mobile Number"
              [ngModelOptions]="{ standalone: true }"
            />
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="24">
        <nz-form-label>Sim Number</nz-form-label>
        <nz-form-item>
          <nz-form-control>
            <input
              nz-input
              type="number"
              [(ngModel)]="sim_nu"
              placeholder="Sim Number"
              [ngModelOptions]="{ standalone: true }"
            />
          </nz-form-control>
        </nz-form-item>
      </div>

      <div
        nz-col
        nzSpan="24"
        class="flex justify-end"
        style="gap: 16px; margin-top: 20px"
      >
        <button
          nz-button
          nzType="default"
          nzDanger
          (click)="closedvcFrm()"
          style="padding: 0 24px"
        >
          Cancel
        </button>
        <button
          nz-button
          nzType="primary"
          (click)="addDevice()"
          [disabled]="!perms.canWrite()"
          [title]="
            !perms.canWrite() ? 'You do not have permission to save' : ''
          "
          class="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700"
          style="padding: 0 32px"
        >
          Add
        </button>
      </div>
    </div>
  </ng-container>
</nz-drawer>
